<template>
    <div>
        <div>
            <md-card style="margin-bottom: 15px">
                <md-card-header>
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <h1 class="md-title">Werkbonnen</h1>
                        </div>

                        <div class="md-layout-item" style="text-align-last: right">
                            <md-button class="md-fab md-mini md-primary" @click="showCreateNewWorkOrder()">
                                <md-icon>add</md-icon>
                            </md-button>
                        </div>
                    </div>
                    <div>
                        <md-field>
                            <md-input
                                v-model="workOrderSearchFilter.client_name"
                                placeholder="Zoek op naam..."
                                type="text"
                                v-debounce:300ms="searchWorkOrders"
                            />
                        </md-field>
                    </div>
                </md-card-header>
                <md-card-content>
                    <div>
                        <md-checkbox
                            v-model="workOrderStatusCreatedChecked"
                            @change="checkboxStatusClicked(WorkOrderStatus.created, workOrderStatusCreatedChecked)"
                            >Created
                        </md-checkbox>
                        <md-checkbox
                            v-model="workOrderStatusFinishedChecked"
                            @change="checkboxStatusClicked(WorkOrderStatus.finished, workOrderStatusFinishedChecked)"
                            >Finished
                        </md-checkbox>
                        <md-checkbox
                            v-model="workOrderStatusInvoicedChecked"
                            @change="checkboxStatusClicked(WorkOrderStatus.invoiced, workOrderStatusInvoicedChecked)"
                            >Invoiced
                        </md-checkbox>
                        <md-checkbox
                            v-model="workOrderStatusCancelledChecked"
                            @change="checkboxStatusClicked(WorkOrderStatus.cancelled, workOrderStatusCancelledChecked)"
                            >Cancelled
                        </md-checkbox>
                    </div>
                </md-card-content>
            </md-card>
        </div>

        <div>
            <md-card
                v-for="workOrder in workOrderList"
                :key="workOrder.work_order_id"
                style="margin-bottom: 15px; cursor: pointer"
            >
                <md-card-header>
                    <div class="md-layout md-gutter md-alignment-top-right">
                        <div class="md-layout-item" @click="toggleWorkOrderDetail(workOrder)">
                            <div class="md-subheading md-layout-item md-layout">
                                <div>
                                    <md-icon v-if="!workOrder.showDetail">expand_more</md-icon>
                                    <md-icon v-if="workOrder.showDetail">expand_less</md-icon>
                                </div>
                                Werkbon ID:
                                {{ workOrder.work_order_id }}
                                <md-badge
                                    v-if="workOrder.status === WorkOrderStatus.created"
                                    class="md-square"
                                    md-content="Created"
                                />
                                <md-badge
                                    v-if="workOrder.status === WorkOrderStatus.finished"
                                    class="md-square"
                                    md-content="Finished"
                                    style="background-color: #4de473"
                                />
                                <md-badge
                                    v-if="workOrder.status === WorkOrderStatus.invoiced"
                                    class="md-square"
                                    md-content="Invoiced"
                                    style="background-color: #e40007; color: white"
                                />
                            </div>

                            <div class="md-subhead">
                                {{
                                    workOrder.client.client_data
                                        ? workOrder.client.client_data.first_name +
                                          ' ' +
                                          workOrder.client.client_data.last_name +
                                          ' - '
                                        : 'Klant niet gekend'
                                }}
                                <span>{{ workOrder.creation_date | formatDate }} </span>
                            </div>
                        </div>

                        <div class="md-layout-item" style="text-align: right; max-width: 150px">
                            <md-button
                                @click="downloadWorkOrder(workOrder.work_order_id)"
                                class="md-raised md-dense md-icon-button md-layout-item"
                            >
                                <md-icon>arrow_downward</md-icon>
                            </md-button>
                            <md-button
                                :disabled="workOrder.status !== WorkOrderStatus.created"
                                @click="showEditMode(workOrder)"
                                class="md-raised md-dense md-icon-button md-layout-item"
                            >
                                <md-icon>edit</md-icon>
                            </md-button>

                            <md-button
                                :disabled="workOrder.status !== WorkOrderStatus.created"
                                @click="showCancelWorkOrder(workOrder.work_order_id)"
                                class="md-raised md-dense md-icon-button md-layout-item"
                            >
                                <md-icon>clear</md-icon>
                            </md-button>
                        </div>
                    </div>
                </md-card-header>

                <md-card-content v-if="workOrder.showDetail">
                    <md-button
                        @click="showCommentDialog(workOrder.work_order_id)"
                        class="md-dense md-raised md-primary"
                    >
                        Add comment
                        <!--   <md-icon>comment</md-icon>-->
                    </md-button>

                    <md-list v-if="workOrder.comments" class="md-triple-line">
                        <div v-for="(comment, index) in workOrder.comments" :key="index">
                            <md-list-item>
                                <div class="md-list-item-text">
                                    <span>{{
                                        comment.created_by_user.first_name + ' ' + comment.created_by_user.last_name
                                    }}</span>
                                    <span style="color: rgba(0, 0, 0, 0.34); font-size: 11px"
                                        ><hour-display
                                            :date-time="comment.creation_date"
                                            date-time-format="DD/MM/YYYY HH:mm:ss"
                                    /></span>
                                    <p>{{ comment.data.comment }}</p>
                                </div>
                            </md-list-item>

                            <md-divider></md-divider>
                        </div>
                    </md-list>
                </md-card-content>
            </md-card>
        </div>
        <div>
            <div class="center" v-if="workOrderList.length > 0">
                <div class="pagination">
                    <div class="page-item">
                        <a aria-label="Previous" class="page-link" @click="setPage(currentPageIndex - 1)">
                            <!--<md-icon>arrow_back_ios</md-icon>-->
                            <template>Prev</template>
                        </a>
                    </div>
                    <!--<li style="align-self: flex-end;" v-if="currentPageIndex > 3">...</li>-->
                    <div v-for="pageNo in maxPages" class="page-item" :key="pageNo">
                        <a
                            v-if="pageNo >= currentPageIndex - 2 && pageNo <= currentPageIndex + 2"
                            class="page-link"
                            v-bind:class="{ active: pageNo === currentPageIndex + 1 }"
                            @click="setPage(pageNo - 1)"
                        >
                            {{ pageNo }}
                        </a>
                    </div>
                    <!--<li style="align-self: flex-end;" v-if="currentPageIndex < maxPages -2">...</li>-->
                    <div class="page-item" v-bind:class="{ disable: currentPageIndex + 1 !== this.maxPages }">
                        <a
                            v-if="currentPageIndex + 1 !== this.maxPages"
                            aria-label="Next"
                            class="page-link"
                            @click="setPage(currentPageIndex + 1)"
                        >
                            <template>Next</template>
                        </a>
                    </div>
                </div>
                <div>
                    <span style="color: #ff9800">
                        {{
                            currentPageSize * (currentPageIndex + 1) -
                            currentPageSize +
                            1 +
                            ' - ' +
                            currentPageSize * (currentPageIndex + 1) +
                            ' of ' +
                            maxPages * currentPageSize
                        }}
                    </span>
                </div>
            </div>
        </div>
        <md-dialog :md-active.sync="showCancel">
            <md-dialog-title>Cancel Workbon</md-dialog-title>

            <md-dialog-content> Ben je zeker dat je werkbon wilt annuleren?</md-dialog-content>

            <md-dialog-actions>
                <md-button class="md-primary" @click="cancelCancelWorkOrder()">No</md-button>
                <md-button class="md-primary" @click="cancelWorkOrder()">Yes</md-button>
            </md-dialog-actions>
        </md-dialog>

        <!-- Todo make this a reusable component => also used in workorder comment-->
        <md-dialog :md-active.sync="showComment">
            <md-dialog-title>Comment</md-dialog-title>

            <md-dialog-content>
                <md-field>
                    <label for="comment">Comment</label>
                    <md-textarea id="comment" name="comment" v-model="comment.data.comment"></md-textarea>
                </md-field>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button @click="cancelComment()" class="md-primary">Cancel</md-button>
                <md-button @click="addComment()" class="md-primary">Add comment</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import * as toastr from 'toastr';
import router from '@/router';
import ClientSearchModal from '@/components/client-search-modal/ClientSearchModal.vue';
import HourDisplay from '@/components/utils/HourDisplay.vue';
import {
    ICommentEntity,
    IWorkOrderEntity,
    IWorkOrderSearchEntity,
    IWorkOrderSearchFilterEntity,
    WorkOrderApi,
    WorkOrderCommentApi,
    WorkOrderStatus,
} from '@phrospr/api-backend';
import StarRating from 'vue-star-rating';
import { downloadFileFromApi } from '@phrospr/lib-web-core';

export interface WorkOrderOverView extends IWorkOrderEntity {
    showDetail?: boolean;
}

@Component({
    components: {
        ClientSearchModal,
        HourDisplay,
        StarRating,
    },
    beforeRouteEnter: async function (to, from, next) {
        try {
            next((component: WorkOrderOverview) => component.setPage(0));
        } catch (err) {
            console.error(err);
        }
    },
})
export default class WorkOrderOverview extends Vue {
    workOrderList: Array<WorkOrderOverView> = [];

    workOrderSearchCore: IWorkOrderSearchEntity = {
        limit: 10,
        offset: 10,
        show: {
            client: true,
            created_by_user: true,
            work_order_technician_user: true,
        },
    };

    workOrderSearchFilter: IWorkOrderSearchFilterEntity = {
        work_order_states: [WorkOrderStatus.created, WorkOrderStatus.finished],
        client_name: '',
        client_number: '',
        work_orders_from_logged_in_user: true,
    };

    workOrderStatusCreatedChecked: boolean = true;
    workOrderStatusFinishedChecked: boolean = true;
    workOrderStatusInvoicedChecked: boolean = false;
    workOrderStatusCancelledChecked: boolean = false;

    public WorkOrderStatus = WorkOrderStatus;

    currentPageSize = 10;
    currentPageIndex = 1;
    maxPages = 1;

    showCancel: boolean = false;
    workOrderIdToCancel: number;

    showComment: boolean = false;
    comment: ICommentEntity = {
        data: {
            comment: '',
            contacted_info: {},
        },
        comment_id: null,
        creation_date: null,
        created_by_user_id: null,
    };
    workOrderIdToAddComment: number;

    constructor() {
        super();
        this.$store.commit('setWorkOrderCreateSettings', null);
    }

    public checkboxStatusClicked(value: WorkOrderStatus, checked: boolean) {
        if (checked === true) {
            this.workOrderSearchFilter?.work_order_states?.push(value);
        } else {
            let index = this.workOrderSearchFilter?.work_order_states?.indexOf(value);
            this.workOrderSearchFilter?.work_order_states?.splice(index, 1);
        }
        this.searchWorkOrders();
    }

    searchWorkOrders() {
        this.setPage(0);
        this.getWorkOrders(
            this.workOrderSearchFilter.client_name,
            this.workOrderSearchFilter.work_order_states,
            this.workOrderSearchCore,
        );
    }

    public async getWorkOrders(
        client_name?: string,
        workOrderStates?: WorkOrderStatus[],
        workOrderSearchCore?: IWorkOrderSearchEntity,
    ) {
        try {
            const workOrders = await WorkOrderApi.getWorkOrderListPost({
                work_order_filter: workOrderSearchCore,
            });

            this.workOrderList = workOrders.data.records;
            this.maxPages = Math.ceil(workOrders.data.total / this.currentPageSize);
        } catch (e) {
            console.log(e);
            toastr.error('Something went wrong with server call to retrieve the workOrders');
        }
    }

    public async downloadWorkOrder(work_order_id: number) {
        try {
            await downloadFileFromApi(await WorkOrderApi.downloadWorkOrder(work_order_id, { responseType: 'blob' }));
        } catch (e) {
            console.log(e);
            toastr.error('Something went wrong with server call');
        }
    }

    showCancelWorkOrder(work_order_id: number) {
        this.showCancel = true;
        this.workOrderIdToCancel = work_order_id;
    }

    cancelCancelWorkOrder() {
        this.showCancel = false;
        this.workOrderIdToCancel = null;
    }

    public async cancelWorkOrder() {
        try {
            await WorkOrderApi.cancelWorkOrder(this.workOrderIdToCancel);
            this.showCancel = false;
            this.setPage(this.currentPageIndex);
        } catch (e) {
            toastr.error('Something went wrong with server call');
        }
    }

    public showEditMode(workOrder: IWorkOrderEntity) {
        if (workOrder.status !== WorkOrderStatus.created) {
            return toastr.error('Werkbon is al goed gekeurd en afgewerkt, kan dit niet meer wijzigen');
        }

        this.$store.commit('setWorkOrderCreateSettings', {
            work_order_id: workOrder.work_order_id,
            editMode: true,
            client_id: workOrder.client_id,
        });
        return router.push({ path: `/workOrder/upsert/${workOrder.work_order_id}` });
    }

    public async showCreateNewWorkOrder() {
        await router.push({ path: '/workOrder/upsert' });
    }

    public async toggleWorkOrderDetail(workOrder: WorkOrderOverView) {
        workOrder.showDetail = !workOrder.showDetail;
        this.$mount();
        if (workOrder.showDetail) await this.loadWorkOrderComments(workOrder);
    }

    public async loadWorkOrderComments(workOrder: WorkOrderOverView) {
        try {
            workOrder.comments = (await WorkOrderCommentApi.listWorkOrderComments(workOrder.work_order_id)).data;
            workOrder.comments.sort((a, b) => (b.comment_id ?? 0) - (a.comment_id ?? 0));
            this.$mount();
        } catch (e) {
            console.log(e);
        }
    }

    public async setPage(pageIndex: number) {
        if (pageIndex < 0) return;
        if (pageIndex > this.maxPages - 1 && pageIndex < 0)
            return console.log('page to high', pageIndex, this.maxPages);
        this.currentPageIndex = pageIndex;

        this.workOrderSearchCore = {
            ...this.workOrderSearchCore,
            limit: this.currentPageSize,
            offset: this.currentPageSize * this.currentPageIndex,
            filter: this.workOrderSearchFilter,
        };

        await this.getWorkOrders(
            this.workOrderSearchCore?.filter?.client_name,
            this.workOrderSearchCore?.filter?.work_order_states,
            this.workOrderSearchCore,
        );
    }

    public async addComment() {
        if (this.comment.data.comment != '') {
            try {
                await WorkOrderCommentApi.addWorkOrderComment(this.workOrderIdToAddComment, {
                    ...this.comment,
                    creation_date: new Date(),
                    created_by_user: undefined,
                    comment_id: null,
                    created_by_user_id: null,
                });
                this.showComment = false;
                this.comment.data.comment = '';
                toastr.success('commentaar geregistreerd');
                const workOrder = this.workOrderList.find(x => x.work_order_id === this.workOrderIdToAddComment);
                if (workOrder) await this.loadWorkOrderComments(workOrder);
            } catch (e) {
                console.log(e);
                toastr.error('er ging iets mis in het registreren van de comment');
            }
        } else {
            toastr.error('commentaar is leeg');
        }
    }

    public showCommentDialog(work_order_id: number) {
        this.showComment = true;
        this.workOrderIdToAddComment = work_order_id;
    }

    public cancelComment() {
        this.showComment = false;
        this.workOrderIdToAddComment = null;
        this.comment.data.comment = '';
    }
}
</script>

<style scoped>
.align-right {
    text-align: right;
}

.md-badge {
    position: relative;
}

.work_order-edit-disabled.md-button {
    background: rgba(0, 0, 0, 0.1);
}

.md-button[disabled] {
    opacity: 0.5;
}

.md-card-header {
    padding: 8px;
}

.center {
    text-align: center;
    width: 100%;
}

.pagination {
    border-radius: 0.25rem;
    display: inline-flex;
    padding: 2px;
}

.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: 0;
    line-height: 1.25;
    color: #2196f3;
    background-color: transparent;
    border: 0 solid #dee2e6;
    cursor: pointer;
}

.pagination a span {
    border: 0;
    transition: all 0.3s;
    margin: 0 3px;
    padding: 0;
    min-width: 30px;
    height: 30px;
    line-height: 30px;
    text-transform: uppercase;
    background: transparent;
    text-align: center;
    cursor: pointer;
}

.pagination a.active {
    border-radius: 30px !important;
    background-color: #ff9800;
    border-color: #ff9800;
    color: #fff !important;
    box-shadow: 0 4px 5px 0 rgba(255, 152, 0, 0.14), 0 1px 10px 0 rgba(255, 152, 0, 0.12),
        0 2px 4px -1px rgba(255, 152, 0, 0.2);
}
</style>
